import { useEffect, useRef, useState } from "react";
import { NAME_COL_WIDTH } from "./AccessModulesHistoric";

export function LineTimeline({ widthCol, timelineContainerRef, startDate, endDate, ...props }) {
   const [show, setShow] = useState(false);
   const [date, setDate] = useState();
   const ref = useRef();

   useEffect(() => {
      if (!ref.current || !timelineContainerRef.current) return;
      const targetEl = timelineContainerRef.current;

      const onMouseEnter = (e) => {
         setShow(true);
      }

      const onMouseLeave = (e) => {
         setShow(false);
      }

      const onMouseMove = (e) => {
         const rect = targetEl.getBoundingClientRect();

         const left = e.clientX;

         if (left <= (rect.left + NAME_COL_WIDTH)) {
            setShow(prev => prev ? false : prev);
         } else {
            setShow(prev => !prev ? true : prev);
         }

         const timelineLeft = (left + targetEl.scrollLeft - (NAME_COL_WIDTH + rect.left + 12));
         const currentTime = startDate.getTime() + (((1000 * 60 * 60) * timelineLeft) / widthCol);
         setDate(new Date(currentTime));

         ref.current.style.setProperty(`--lineTop`, `${rect.top}px`);
         ref.current.style.setProperty(`--lineLeft`, `${left}px`);
         ref.current.style.setProperty(`--dateTop`, `${e.clientY}px`);
         ref.current.style.setProperty(`--lineHeight`, `${rect.height}px`);
      }

      targetEl.addEventListener(`mousemove`, onMouseMove);
      targetEl.addEventListener(`mouseenter`, onMouseEnter);
      targetEl.addEventListener(`mouseleave`, onMouseLeave);

      return () => {
         targetEl.removeEventListener(`mousemove`, onMouseMove);
         targetEl.removeEventListener(`mouseenter`, onMouseEnter);
         targetEl.removeEventListener(`mouseleave`, onMouseLeave);
      }
   }, [
      ref.current,
      timelineContainerRef.current,
      widthCol,
      startDate,
      endDate,
   ]);

   return (
      <div ref={ref}>
         <div className={`fixed! pointer-events-none! z-50 w-px h-(--lineHeight) opacity-60 top-(--lineTop) left-(--lineLeft) bg-(--textColor) ${show ? '' : 'hidden'}`}></div>
         <div
            className={`fixed pointer-events-none! opacity-90 w-fit top-(--dateTop) left-(--lineLeft) -translate-x-1/2 -translate-y-full text-(--textColor) text-xs text-center flex flex-col gap-[2px] z-90 bg-(--bodyBackgroundColor) shadow-lg rounded-lg p-2.5! border! border-(--borderColor)! box-border! ${show ? '' : 'hidden'}`}
         >
            <span>{date?.toLocaleDateString()}</span>
            <span>{date?.toLocaleTimeString()}</span>
         </div>
      </div>
   );
}